import { Check } from "lucide-react";
import "./styles/FormAside.css";

interface Step {
  title: string;
  text: string;
}

interface FormAsideProps {
  heading: string;
  points: string[];
  steps: Step[];
  footnote?: string;
}

/**
 * Reassurance panel shown beside a lead-capture form. Reduces form anxiety
 * (trust bullets + "how it works" + a security note) without adding any
 * distracting interactive elements that would hurt completion.
 */
export default function FormAside({ heading, points, steps, footnote }: FormAsideProps) {
  return (
    <aside className="form-aside">
      <h3 className="form-aside-heading">{heading}</h3>

      <ul className="form-aside-points">
        {points.map((p, i) => (
          <li key={i}>
            <Check className="form-aside-check" />
            <span>{p}</span>
          </li>
        ))}
      </ul>

      <div className="form-aside-steps">
        <p className="form-aside-steps-title">How it works</p>
        {steps.map((s, i) => (
          <div className="form-aside-step" key={i}>
            <span className="form-aside-step-num">{i + 1}</span>
            <div>
              <p className="form-aside-step-title">{s.title}</p>
              <p className="form-aside-step-text">{s.text}</p>
            </div>
          </div>
        ))}
      </div>

      {footnote && <p className="form-aside-note">{footnote}</p>}
    </aside>
  );
}
